/***** Product Main Image Zoom functionality start *****/

function zoominimg(el) {
  if (el.querySelector('.image-magnify-hover') != null) {
    el.querySelector('.image-magnify-hover').style.opacity = '0';
    let backgroundval = "url('" + el.getAttribute('data-val') + "')"
    el.style.backgroundImage = backgroundval;
  }
}
function zoomoutimg(el) {
  if (el.querySelector('.image-magnify-hover') != null) {
    el.querySelector('.image-magnify-hover').style.opacity = '1';
    el.style.backgroundImage = "none";
  }
}

function zoommove(el, e) {
  if (el.querySelector('.image-magnify-hover') != null) {
    let xpert = (e.offsetX * 100) / el.offsetWidth;
    let ypert = (e.offsetY * 100) / el.offsetHeight;
    el.style.backgroundPositionX = xpert + "%";
    el.style.backgroundPositionY = ypert + "%";
  }
}
/***** Product Main Image Zoom functionality end *****/

/***** Product Video functionality start *****/

function showVideo(el) {
  if (el.querySelector('.cover-image') != null) {
    el.querySelector('.cover-image').style.display = 'none';
    el.querySelector('video').classList.remove('display--none');
  }
}
/***** Product Video functionality end *****/
/***** Product tabs start *****/
document.addEventListener('DOMContentLoaded', function (e) {
  var mainTabsToggle = document.querySelectorAll('.product-tabs .tab a');
  var mainTabsContent = document.querySelectorAll('.product-tabs .tab-content');
  mainTabsToggle.forEach((tabToggle) => {
    tabToggle.addEventListener('click', function (e) {
      e.preventDefault();
      mainTabsToggle.forEach((allTabToggle, index) => {
        allTabToggle.parentElement.classList.remove('is-active');
        mainTabsContent[index].classList.remove('is-active');
      });
      var tabsContentHref = this.getAttribute('href');
      var tabsContent = document.querySelector(tabsContentHref);
      tabsContent.classList.add('is-active');
      this.parentElement.classList.add('is-active');
    });
  });
  var bvTabsToggle = document.querySelectorAll('.bv-app-tabs .tab a');
  var bvTabsContent = document.querySelectorAll('.bv-app-tabs .tab-content');
  bvTabsToggle.forEach((tabToggle) => {
    tabToggle.addEventListener('click', function (e) {
      e.preventDefault();
      bvTabsToggle.forEach((allTabToggle, index) => {
        allTabToggle.parentElement.classList.remove('is-active');
        bvTabsContent[index].classList.remove('is-active');
      });
      var tabsContentHref = this.getAttribute('href');
      var tabsContent = document.querySelector(tabsContentHref);
      tabsContent.classList.add('is-active');
      this.parentElement.classList.add('is-active');
    });
  });

  showChangeColor();

});

function debounce(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this, args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

let previousWidth = window.innerWidth;

document.querySelectorAll('.tabs-accordion summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (window.innerWidth < 767 && summary.closest('.tab-content.accordion') != null) {
    summary.setAttribute('aria-expanded', false);
    summary.closest('details').removeAttribute('open');
  }

  window.addEventListener('resize', debounce(function (e) {
    let currentWidth = window.innerWidth;

    // Check for a significant resize
    if (Math.abs(currentWidth - previousWidth) > 10) {
      if (currentWidth < 767 && summary.closest('.tab-content.accordion') != null) {
        summary.setAttribute('aria-expanded', false);
        summary.closest('details').removeAttribute('open');
      } else if (summary.closest('.tab-content.accordion') != null) {
        summary.setAttribute('aria-expanded', true);
        summary.closest('details').setAttribute('open', '');
      }
      previousWidth = currentWidth;
    }
  }, 250)); // Debounce with a delay of 250ms
});

/***** Product tabs  JS end *****/

/***** Product Add to Cart JS start *****/
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}
let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }
  subscribers[eventName] = [...subscribers[eventName], callback];
  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}

async function updateCart(response) {
  this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

  if (response.sections) {
    this.cart.renderContents(response);
  } else {
    const cartDrawerSection = await fetch(window.location.pathname + '?sections=cart-drawer').then(res => res.json())

    const object = {
      sections: {
        ...cartDrawerSection
      }
    }

    this.cart.renderContents(object);
  }

  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    cartDrawer.open();
    this.cart.classList.remove('is-empty');
  }

  fetch('/cart.js', {
    method: 'GET',
    cache: 'no-cache'
  })
  .then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json();
  })
  .then((cart) => {
    document.querySelectorAll('.buy-button-wrapper .added-success').forEach(success => {
      success.style.display = 'block';
      setTimeout(() => {
        success.style.display = 'none';
      }, 3000);
    });

    const itemCountElements = document.querySelectorAll('.minicart-quantity .item-count');

    itemCountElements.forEach((itemCountElement) => {
      itemCountElement.textContent = cart.item_count;
    });

    if (cart.item_count >= 1) {
      this.cart.classList.remove('is-empty')
    }
  })
  .catch(error => {
    console.error('Error updating cart:', error);
  });
}

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};


if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if(this.form) {
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      this.submitButton.setAttribute('aria-disabled', true);
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, { source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message });
            this.handleErrorMessage(response.description);

            return;
          }

          updateCart(response);
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.removeAttribute('aria-disabled');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

const createMainMediaSwiper = () => {
  return new Swiper('.pdp-zoom-swiper', {
  zoom: true,
  navigation: {
    nextEl: ".pdp-zoom-swiper-wrapper .swiper-button-next",
    prevEl: ".pdp-zoom-swiper-wrapper .swiper-button-prev",
  },
  thumbs: {
    swiper: document.querySelector('.swiper-container.thumbnails')
  },
});
}

addSwiperCssJs();
this.mainMediaSwiper = createMainMediaSwiper();

this.mainMediaSwiper.on('slideChange', (swiper) => {
  const slidesWithVideos = swiper.slides.filter((slide) => slide.querySelector('video'));

  slidesWithVideos.forEach((slideWithVideo) => {
    const video = slideWithVideo.querySelector('video');
    video.pause();
  });
});

const createThumbnailSwiper = () => new Swiper('.swiper-container.thumbnails', {
  keyboard: true,
  slidesPerView: 5,
  slidesPerGroup: 5,
  slideToClickedSlide: true,
  clickable: true,
  spaceBetween: 5,
  navigation: {
    nextEl: ".swiper-container.thumbnails .swiper-button-next-thumb",
    prevEl: ".swiper-container.thumbnails .swiper-button-prev-thumb",
  }
});

this.thumbnailSwiper = createThumbnailSwiper();

/***** Product Variants JS start *****/
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    checkOutOfStockInventory();
  }

  onVariantChange() {
    if (this.mainMediaSwiper) {
      this.mainMediaSwiper.destroy(true, true);
    }

    if (this.thumbnailSwiper && this.querySelectorAll('.swiper-container.thumbnails').length > 0) {
      this.thumbnailSwiper.destroy(true, true);
    }

    this.mainMediaSwiper = createMainMediaSwiper();

    this.thumbnailSwiper = createThumbnailSwiper();

    this.updateOptions();
    this.updateMasterId();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.updateVariantContent();
    this.renderProductInfo();
    this.updateRelatedPatterns();
    if (!this.currentVariant) {
      this.setUnavailable();
    } else {
      this.updateURL();
      this.filterMedia();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = [];

    const selects = Array.from(this.querySelectorAll('select'));
    const radios = Array.from(this.querySelectorAll('input[type="radio"]:checked'));
    selects.forEach((select) => {
      this.options.push(select.value);
    });

    radios.forEach((radio) => {
      this.options.push(radio.value);
    });
  }

  filterMedia() {
    let selected_variant = this.currentVariant?.featured_media.alt;
    let selected_attribute = '[thumbnail-color="' + selected_variant + '"]';
    let all_variants = '[thumbnail-color="All Variants"]';

    // Hide all elements first
    document.querySelectorAll('[thumbnail-color]').forEach(function (el) {
      el.style.display = 'none';
    });

    if (selected_variant == selected_variant) {
      // Get all the elements to reposition in an array
      let elementsToReposition = Array.from(document.querySelectorAll(selected_attribute));

      // Reverse the array to keep the original order when repositioning
      elementsToReposition.reverse().forEach(function (el) {
        el.style.display = 'block';

        // Get parent of the element
        let parent = el.parentNode;

        // Remove the element from its current position
        parent.removeChild(el);

        // Append the element as the first child of its parent
        parent.insertBefore(el, parent.firstChild);
      });
    }

    // Show all variants
    document.querySelectorAll(all_variants).forEach(function (el) {
      el.style.display = 'block';
    });
  }

  addToCartButtonTextFor(metafieldData) {
    if (metafieldData.pre_order) {
      return 'Pre-Order Now';
    }

    return 'Add to Cart';
  }

  updateVariantContent() {
    const mainProductContainer = this.closest('.main-product');
    let metafieldData = this.getVariantMetafieldData();
    if (this.currentVariant) {
      var variantID = this.currentVariant.id.toString();
    } else {
      document.querySelector('label.color-label.active__option')?.click();
    }
    metafieldData = metafieldData[0][variantID];

    var titles = document.querySelectorAll('.product__title h1');
    var title = document.querySelector('.product__title h1').dataset.label;
    title = title.toString();

    let variantTitle = this.currentVariant?.title || '';
    const titleTextWithVariant = `${title}, ${variantTitle}`;

    if (this.currentVariant) {
      const skuElements = document.querySelectorAll('.product__sku .sku');
      skuElements.forEach((skuElement) => {
        skuElement.textContent = metafieldData.sku;
      });
      var currentVariantOptions = this.currentVariant.options;
    }

    this.querySelectorAll('.product-form__input .current__option').forEach((element, index) => {
      element.textContent = currentVariantOptions[index];
    });

    titles.forEach(function (el) {
      el.innerHTML = titleTextWithVariant;
    })

    if (metafieldData.hasOwnProperty("variant_status")){
      if(metafieldData["variant_status"].includes("Price Drop")){
        mainProductContainer.classList.add('status-price-drop')
      } else {
        mainProductContainer.classList.remove('status-price-drop')
      }
      if (metafieldData["variant_status"].includes("New")) {
        mainProductContainer.classList.add('status-new')
      } else {
        mainProductContainer.classList.remove('status-new')
      }
      if (metafieldData["variant_status"].includes("Limted Edition")) {
        mainProductContainer.classList.add('status-limited-edition')
      } else {
        mainProductContainer.classList.remove('status-limited-edition')
      }
      if (metafieldData["variant_status"].includes("Coming Soon")) {
        mainProductContainer.classList.add('status-coming-soon')
      } else {
        mainProductContainer.classList.remove('status-coming-soon')
      }
    } else {
      mainProductContainer.classList.remove('status-price-drop')
      mainProductContainer.classList.remove('status-new')
      mainProductContainer.classList.remove('status-limited-edition')
      mainProductContainer.classList.remove('status-coming-soon')

      const newBadge = mainProductContainer.querySelector('.product-gallery-viewer .new-badge')
      newBadge && newBadge.setAttribute('hidden', true)

      const priceDropBadge = mainProductContainer.querySelector('.product-gallery-viewer .price-drop-badge')
      priceDropBadge && priceDropBadge.setAttribute('hidden', true)
    }

    const exclusiveWrapper = mainProductContainer.querySelector('.exclusive-wrapper')
    if (exclusiveWrapper) {
      exclusiveWrapper.innerHTML = metafieldData.hasOwnProperty("exclusive") ? `<p class='product__text exlusive_message'>${metafieldData["exclusive"]}</p>` : ''
    }
    mainProductContainer.classList.toggle('status-exclusive', metafieldData.hasOwnProperty("exclusive"))

    const oosInventoryEl = mainProductContainer.querySelector('.out-of-stock.inventory')
    const inStockInventoryEl = mainProductContainer.querySelector('.in-stock.inventory')
    const warningInventoryEl = mainProductContainer.querySelector('.warning-stock.inventory')
    const bisForm = mainProductContainer.querySelector('.bis--form')
    const availableInEl = document.querySelector('available-in')

    if (!metafieldData.hasOwnProperty("exclusive")) {
      if (metafieldData.hasOwnProperty("stock")){
        var stock = metafieldData["stock"]
        const quantityInput = document.querySelector('.product-form__quantity .quantity__input');
        if (quantityInput) {
          quantityInput.setAttribute('max', stock);
          quantityInput.value = stock < 1 ? 0 : 1;
        }
        mainProductContainer.classList.toggle('disable-back-in-stock', metafieldData.disable_back_in_stock === 'true')

        if (stock != 'not-in-market') {
          stock = parseInt(metafieldData["stock"])
          if (exclusiveWrapper) {
            exclusiveWrapper.innerHTML = ''
          }

          mainProductContainer.classList.remove('status-exclusive')
          if (stock < 1) {
            mainProductContainer.classList.add('status-out-of-stock');
            oosInventoryEl && oosInventoryEl.setAttribute('hidden', false)
            inStockInventoryEl && inStockInventoryEl.setAttribute('hidden', true)
            warningInventoryEl && warningInventoryEl.setAttribute('hidden', true)

            this.toggleAddButton(true, this.addToCartButtonTextFor(metafieldData), true);

            var bisOverride = metafieldData['disable_back_in_stock']
            if (bisForm) {
              if (bisOverride === undefined) {
                bisForm.classList.remove('disable-back-in-stock');
              } else if (bisOverride == 'true') {
                bisForm.classList.add('disable-back-in-stock')
              } else {
                bisForm.classList.remove('disable-back-in-stock');
              }
            }
          } else if(stock > 30) {
            mainProductContainer.classList.remove('status-out-of-stock')

            oosInventoryEl && oosInventoryEl.setAttribute('hidden', true)
            inStockInventoryEl && inStockInventoryEl.setAttribute('hidden', false)
            warningInventoryEl && warningInventoryEl.setAttribute('hidden', true)

            this.toggleAddButton(false, this.addToCartButtonTextFor(metafieldData), true);
          } else {
            mainProductContainer.classList.remove('status-out-of-stock')

            oosInventoryEl && oosInventoryEl.setAttribute('hidden', true)
            inStockInventoryEl && inStockInventoryEl.setAttribute('hidden', true)
            warningInventoryEl && warningInventoryEl.setAttribute('hidden', false)

            this.toggleAddButton(false, this.addToCartButtonTextFor(metafieldData), true);
          }
        } else {
          if(metafieldData.product_type != 'Pattern'){
            if (metafieldData.inventories) {
              var availableIn = 'Available Only In';

              if (metafieldData.inventories.includes("Bassett")){
                availableIn = availableIn + ' Canada';
              }
              if (metafieldData.inventories.includes("Albany")){
                availableIn = availableIn + ' United States';
              }

              availableIn = availableIn.replace('Canada United States','Canada and United States');
              availableInEl.textContent = availableIn
              availableInEl.classList.add('has-data')
            } else {
              availableInEl.classList.remove('has-data')
            }

            mainProductContainer.classList.add('status-not-in-market');
            mainProductContainer.find('.exclusive-wrapper').html("<p class='product__text exlusive_message'>Not available in " + metafieldData["market"] + "</p>");
          }
        }

        const warningInventorySpanEl = warningInventoryEl.querySelector('span')
        if (warningInventorySpanEl) {
          warningInventorySpanEl.textContent = `Hurry, only ${stock} left!`
        }

        const bisFormFormEl = bisForm?.querySelector('#bis_form')
        if (bisFormFormEl) {
          bisFormFormEl.style.display = 'block';
        }

        const bisFormSuccess = bisForm?.querySelector('.success-message')
        if (bisFormSuccess) {
          bisFormSuccess.style.display = 'none';
        }
      }
    }

    //UPDATE PATTERN PRODUCTS GOES HERE
    if(metafieldData.hasOwnProperty("product_type")){
      if (metafieldData["product_type"] == 'Pattern') {
        let totalPrice = 0;
        const patternLink = metafieldData['pattern_download'];
        const downloadButton = document.querySelector('.product__info-container .download-pattern-btn');
        const disabledKitGroup = document.querySelector('.disabled-kit .product-group');
        const totalPriceElement = document.querySelector('.total-price-amount');
        const addToCartButton = document.querySelector('.disabled-kit #add-to-cart');

        if (downloadButton) {
          downloadButton.setAttribute('href', patternLink);
        }

        const patternItems = metafieldData['patternVariants'];
        let stepCount = 1;
        let hasAccessories = false;

        let accessoriesHTML = '<span class="product-variations-title"><span class="product-variations-title-number"><span class="product-variations-title-number-text">{{stepCount}}</span></span><span class="product-variation-title-name-text" role="heading">Accessories</span></span><div class="custom-kit-colors" id="custom-kit-accessories-' + (this ? this.dataset.section : '') + '"><div class="items">';
        let selectorsHTML = '<span class="product-variations-title"><span class="product-variations-title-number"><span class="product-variations-title-number-text">{{stepCount}}</span></span><span class="product-variation-title-name-text" role="heading">Select Colors</span></span><div class="custom-kit-colors js-kit" id="custom-kit-colors-' + (this ? this.dataset.section : '') + '"><div class="items">';
        const disablePatternVariant = patternItems.some(value => value.product_status === 'Discontinued' || value.variant_status === 'Limited Edition') || ['Discontinued', 'Archived (patterns only)', 'Limited Edition'].includes(metafieldData.product_status);

        if (disablePatternVariant) {
          if (disabledKitGroup) disabledKitGroup.style.display = 'none';
          if (addToCartButton) addToCartButton.setAttribute('disabled', true);
        } else {
          if (disabledKitGroup) disabledKitGroup.style.display = 'block';
          if (addToCartButton) addToCartButton.removeAttribute('disabled');
        }

        patternItems.forEach((value) => {
          const image = value.product_type === 'Tools & Accessories' ?
            `<img src="${value.product_image}" alt=""/>` :
            `<img src="${value.variant_image}" alt=""/>`;

          const title = value.variant_title === 'Default Title' ?
            `<span class="contrast-name-current-value">${value.product_title}</span>` :
            `<span class="contrast-name-current-value">${value.variant_title}</span>`;

          const bothTitles = value.variant_title !== 'Default Title' ?
            `<span class="contrast-name-current">${value.product_title}, ${value.variant_title}</span>` : '';

          const qtyValue = Math.min(parseInt(value.inventory), parseInt(value.required_qty));
          const insufficientInventory = parseInt(value.inventory) < parseInt(value.required_qty) ? 'style="display: inline-block;"' : 'style="display: none;"';

          const inventoryMessage = value.inventory < 1 ?
            `<p class="out-of-stock inventory">Out of Stock</p>` :
            value.inventory > 0 && value.inventory < 31 ?
              `<p class="warning-stock inventory">Hurry, only ${value.inventory} left!</p>` :
              `<p class="in-stock inventory">In Stock</p>`;

          const itemHTML = `
            <div class="contrast clearfix">
              <div class="contrast-image">${image}</div>
              <div class="contrast-right-global">
                <div class="contrast-name-top contrast-name-top--${value.variant_id}">${title}</div>
                <div class="contrast-actions">
                  <div class="contrast-name">${bothTitles}</div>
                  <div class="contrast-right quantity-price">
                    <div class="contrast-qty-container">
                      <span class="contrast-qty-label">Qty</span>
                      <input class="contrast-qty" type="number" data-variant-id="${value.variant_id}" onchange="qtyChangeFunction(this)" data-quantity-required="${value.required_qty}" max="${value.inventory}" min="0" value="${qtyValue}">
                    </div>
                    <div class="contrast-price non-active">
                      <span class="contrast-price-sep">x</span>
                      <div class="product-price">
                        <span class="price-sales" data-price="${value.price}">$${(value.price / 100.0).toFixed(2)}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div style="width: 100%;">
                <span class="contrast-qty-required-warning-message" ${insufficientInventory}>This pattern requires at least ${value.required_qty} ball.</span>
              </div>

              <div class="availability-msg">${inventoryMessage}</div>
            </div>
          `;

          if (value.product_type === 'Tools & Accessories') {
            hasAccessories = true;
            accessoriesHTML += itemHTML;
          } else {
            selectorsHTML += itemHTML;
          }

          var itemTotalPrice = qtyValue * value.price;
          totalPrice += itemTotalPrice;
        });

        document.querySelectorAll('.product-option-select').forEach(function () {
          stepCount += 1;
        });

        accessoriesHTML += '</div></div>';
        selectorsHTML += '</div></div>';
        selectorsHTML = selectorsHTML.replace('{{stepCount}}', stepCount);

        if (hasAccessories) {
          stepCount += 1;
          accessoriesHTML = accessoriesHTML.replace('{{stepCount}}', stepCount);
          selectorsHTML += accessoriesHTML;
        }

        var customKitGroup = document.querySelector('#custom-kit-variations .product-group');
        if (customKitGroup) {
          customKitGroup.innerHTML = selectorsHTML;
        }
        if (totalPriceElement) {
          totalPriceElement.textContent = '$' + (totalPrice / 100.0).toFixed(2);
        }
        checkOutOfStockInventory();
      }
    }

    setTimeout(showChangeColor, 500);
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;

      const previousOptionSelectedElement = inputWrappers[index - 1].querySelector(':checked');

      // Check if ':checked' element exists before accessing 'value'
      const previousOptionSelected = previousOptionSelectedElement ? previousOptionSelectedElement.value : null;

      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
    });
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');


        const customKitColors = document.querySelector(`#custom-kit-colors-${this.dataset.section}`);
        const customKitAccessories = document.querySelector(`#custom-kit-accessories-${this.dataset.section}`);
        const variantRadios = document.querySelector(`#variant-radios-${this.dataset.section}`);

        if (customKitColors) {
          this.reRenderSection(`#custom-kit-colors-${this.dataset.section}`, html);
        }

        moveChangeColorToTitle();

        if (customKitAccessories) {
          this.reRenderSection(`#custom-kit-accessories-${this.dataset.section}`, html);
        }

        if (variantRadios) {
          this.reRenderSection(`#variant-radios-${this.dataset.section}`, html);
        }

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  reRenderSection(sectionId, html) {
    const section = document.querySelector(sectionId);
    if(!section) {
      console.error(`reRenderSection Error: section not found for '${sectionId}'`);
      return;
    }
    section.innerHTML = html.querySelector(sectionId).innerHTML;
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    addButtonText.textContent = text

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent).variant;
    return this.variantData;
  }

  getVariantMetafieldData() {
    this.variantMetafieldData = this.variantMetafieldData || JSON.parse(this.querySelector('[type="application/json"]').textContent).metafields;
    return this.variantMetafieldData;
  }

  updateRelatedPatterns() {
    var variantID = this.currentVariant.id.toString();

    const metafields = this.getVariantMetafieldData();
    const relatedPatterns = metafields[0][variantID].related_patterns;
    var rpElement = document.querySelector('.js-related-patterns');
    if (typeof(rpElement) != 'undefined' && rpElement != null){
      if (relatedPatterns) {
        document.querySelector('.js-related-patterns').style.display = 'block';
        document.querySelector('.js-related-patterns-patterns').innerHTML =
          relatedPatterns.map(pattern => `
            <div class="related-pattern__row">
              <div class="related-pattern__image">
                <div class="img-wrapper">
                  ${new Date(pattern.product.published_at) > new Date() ? `
                    <span class="product-badge-new">
                      <img src="{{ 'badge-new.svg' | asset_url }}" width="90" height="90" loading="lazy" alt="New"/>
                    </span>
                  ` : ''}
                  <img src="${pattern.product.featured_image}&width=200" width="100px" height="100px" />
                </div>
              </div>
              <div class="related-pattern__text">
                <a href="/products/${pattern.product.handle}?variant=${pattern.variant.id}">
                  <div class="related-pattern__text__title">${pattern.product.title}</div>
                  <div class="related-pattern__text__explore">Explore Pattern</div>
                </a>
              </div>
            </div>
          `).join('');
          document.querySelector('.js-related-pattern-heading-pattern-singularplural').textContent = relatedPatterns.length > 1 ? 'patterns' : 'pattern';
      } else {
        document.querySelector('.js-related-patterns').style.display = 'none';
      }
    }
  }
}
customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
        // First, look for radio buttons.
        const radioButtons = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
        if (radioButtons.length > 0) {
            const checkedRadio = radioButtons.find((radio) => radio.checked);
            return checkedRadio ? checkedRadio.value : null;
        }

        // If there are no radio buttons, look for a <select> element.
        const selectElement = fieldset.querySelector('select');
        if (selectElement) {
            return selectElement.value;
        }

        return null; // default return value
    }).filter(Boolean);  // This will filter out any null values
  }
}
customElements.define('variant-radios', VariantRadios);

class ShowModalColor extends HTMLElement {
  constructor() {
    super();

    this.querySelectorAll('.close-color-modal').forEach(closeBtn => {
      closeBtn.addEventListener('click', () => {
        this.close();
      });
    })
  }

  show(opener) {
    this.openedBy = opener;
    trapFocusInModal(this);
  }

  close(){
    this.removeAttribute('open');
    cancelTrappedFocusInModal(this);
    if(this.openedBy){
      this.openedBy.focus();
    }
  }
}
customElements.define('show-modal-color', ShowModalColor);

/***** Product Variants JS end *****/
function patternChangeFunction(e) {
  const selectedValue = e.querySelector(":selected").value;
  const inputName = e.id;

  // Update the value of the corresponding input field
  const inputElement = document.querySelector(`.product-form__input [name="${inputName}"]`);
  if (inputElement) {
    inputElement.value = selectedValue;

    // Trigger the 'change' event
    const changeEvent = new Event('change', { bubbles: true });
    inputElement.dispatchEvent(changeEvent);

    // Find and trigger 'click' and 'change' events on the corresponding option
    const optionElement = inputElement.querySelector(`[value="${selectedValue}"]`);
    if (optionElement) {
      const clickEvent = new Event('click', { bubbles: true });
      optionElement.dispatchEvent(clickEvent);

      const changeOptionEvent = new Event('change', { bubbles: true });
      optionElement.dispatchEvent(changeOptionEvent);
    }
  }
}

function showChangeColor() {
  const url = new URL(window.location.href);
  const variantValue = url.searchParams.get("variant");
  const changeColorOpeners = document.querySelectorAll(".colors-modal-wrapper");

  changeColorOpeners.forEach((changeColor) => {
    changeColor.classList.add("hide");

    const variantId = changeColor.getAttribute("data-variant-id");
    if (variantId === variantValue) {
      // Remove default color items
      const defaultChangeColor = document.querySelector(".custom-kit-colors .items--remove");
      if (defaultChangeColor) {
        defaultChangeColor.remove();
      }

      const requiredItemId = changeColor.getAttribute("data-item-id");
      const changeColorWrapper = document.querySelector(`.contrast-name-top--${requiredItemId}`);

      if (changeColorWrapper) {
        // Clone the element
        const clonedChangeColor = changeColor.cloneNode(true);

        // Modify attributes of cloned elements
        const modalOpener = clonedChangeColor.querySelector("modal-opener");
        const openColorModalSpan = clonedChangeColor.querySelector(".open-color-modal");
        const showModalColor = clonedChangeColor.querySelector("show-modal-color");

        if (modalOpener) {
          modalOpener.setAttribute("data-modal", `${modalOpener.getAttribute("data-modal")}--cloned`);
        }

        if (openColorModalSpan) {
          openColorModalSpan.setAttribute(
            "data-open-color-modal",
            `${openColorModalSpan.getAttribute("data-open-color-modal")}--cloned`
          );
        }

        if (showModalColor) {
          showModalColor.setAttribute(
            "data-colors-modal",
            `${showModalColor.getAttribute("data-colors-modal")}--cloned`
          );
          showModalColor.setAttribute("id", `${showModalColor.getAttribute("id")}--cloned`);
        }

        // Remove 'hide' class and append the cloned element
        clonedChangeColor.classList.remove("hide");
        changeColorWrapper.appendChild(clonedChangeColor);
      }
    }
  });
}

function qtyChangeFunction(el){
  let totalPrice = 0;

  const quantityRequired = parseInt(el.getAttribute('data-quantity-required'), 10);
  const inputValue = parseInt(el.value, 10);

  if (inputValue < quantityRequired) {
    el.closest('.contrast')
      .querySelector('.contrast-qty-required-warning-message')
      .style.display = 'inline-block';
  } else {
    el.closest('.contrast')
      .querySelector('.contrast-qty-required-warning-message')
      .style.display = 'none';
  }

  document.querySelectorAll('.quantity-price').forEach((element) => {
    const quantity = parseInt(element.querySelector('.contrast-qty').value, 10);
    const price = parseFloat(element.querySelector('.price-sales').getAttribute('data-price'));

    totalPrice += quantity * price;
  });

  document.querySelector('.total-price-amount').textContent = `$${(totalPrice / 100).toFixed(2)}`;

}

const patternAtc = document.querySelector('[data-pattern-atc]');

if (patternAtc) {
  patternAtc.addEventListener('click', () => {
    patternAddToCart(patternAtc);
  });
}

function patternAddToCart(){
  let formData = { items: [] };

  document.querySelectorAll('.contrast .contrast-qty').forEach((element) => {
    const quantity = parseInt(element.value, 10);
    const variantId = element.getAttribute('data-variant-id');
    const patternTitle = document.querySelector('.product__title.layout-desktop h1').textContent.split(',')[0];

    if (quantity > 0) {
      formData.items.push({
        quantity,
        id: parseInt(variantId, 10),
        properties: { Pattern: patternTitle },
      });
    }
  });

  fetch(`${window.Shopify.routes.root}cart/add.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formData),
  })
  .then((response) => {
    if (response.ok) {
      updateCart(response);
    } else {
      console.error('Error adding items to the cart:', response.statusText);
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  });
};
